import { render, staticRenderFns } from "./EduRecord.vue?vue&type=template&id=4d230254&scoped=true&"
import script from "./EduRecord.vue?vue&type=script&lang=js&"
export * from "./EduRecord.vue?vue&type=script&lang=js&"
import style0 from "./EduRecord.vue?vue&type=style&index=0&id=4d230254&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d230254",
  null
  
)

export default component.exports